import Typography from '@mui/material/Typography';

import { ensureDefined } from '@e-socna/utils';

import type { ServiceUsageCardCmp_ServiceUsage } from './fragments/service-usage.fragment';

interface Props {
  readonly serviceUsage: ServiceUsageCardCmp_ServiceUsage;
}

export const ServiceUsageQuotationSettings = ({
  serviceUsage,
}: Readonly<Props>) => {
  const {
    settings: {
      showAmountsInQuotation,
      showCostsInQuotation,
      showMaterialsInQuotation,
      showQuantitiesInQuotation,
    },
  } = ensureDefined({ settings: serviceUsage.settings });

  return (
    <>
      <Typography color="text.secondary" variant="overline">
        Paramètres Devis
      </Typography>
      <Typography gutterBottom variant="body2">
        Affichage des Montants dans le Devis :{' '}
        {showAmountsInQuotation ? 'Oui' : 'Non'}
      </Typography>
      <Typography gutterBottom variant="body2">
        Affichage des Quantités dans le Devis :{' '}
        {showQuantitiesInQuotation ? 'Oui' : 'Non'}
      </Typography>
      <Typography gutterBottom variant="body2">
        Affichage des Coûts Liés : {showCostsInQuotation ? 'Oui' : 'Non'}
      </Typography>
      <Typography gutterBottom variant="body2">
        Affichage des Matériaux Liés :{' '}
        {showMaterialsInQuotation ? 'Oui' : 'Non'}
      </Typography>
    </>
  );
};
